/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PricingCoverageDto } from './PricingCoverageDto';

/**
 * What the run actually used — so a surprising result can be attributed
 * to the request or to the environment, never guessed at.
 */
export type RunProvenanceDto = {
  engine: string;
  source_mode: RunProvenanceDto.source_mode;
  inventory_snapshot_id: string;
  pricing_coverage?: PricingCoverageDto | null;
};
export namespace RunProvenanceDto {
  export enum source_mode {
    LIVE = 'live',
    PINNED = 'pinned',
  }
}
